import logo from './assets/logo.svg'
import Navbar from './components/Navbar'

function App() {
  return (
    <div className="text-center">
      <Navbar />
      <header className="bg-white min-h-screen flex flex-col items-center justify-center text-[calc(10px+2vmin)] text-black">
        <img src={logo} className="h-[40vmin] pointer-events-none" alt="logo" />
        <p>Coming soon...</p>
      </header>
    </div>
  )
}

export default App
